import { Command as C } from "cmdk";
import { surface } from "./foundation";
export const Command = surface(C, "command", "cyra-command");
export const CommandInput = surface(C.Input, "command-input", "cyra-input");
export const CommandList = surface(C.List, "command-list", "max-h-64 overflow-y-auto p-1");
export const CommandEmpty = surface(C.Empty, "command-empty", "p-3 text-sm text-muted-foreground");
export const CommandGroup = surface(C.Group, "command-group", "cyra-command-group");
export const CommandItem = surface(C.Item, "command-item", "cyra-menu-item");
export const CommandSeparator = surface(C.Separator, "command-separator", "my-1 border-t");
export const CommandShortcut = surface(
  "span",
  "command-shortcut",
  "ml-auto text-xs text-muted-foreground",
);
